import { SupportedLanguages } from '@/lang/lang-settings';
import { ProcedureReportTranslations } from './models/procedure-report-translaction-model';
import { ptBR } from './translactions/pt-BR';
import { enUS } from './translactions/en-US';

export const procedureReport: Record<SupportedLanguages, ProcedureReportTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
